import { Heading, Stack, Text } from '@chakra-ui/react';
import { ReactNode } from 'react';

type Props = {
  label: string | ReactNode;
  value?: string | number;
};

export const NewLabeledValue = ({ label, value }: Props) => {
  const isLabelString = typeof label === 'string';
  const Label: any = isLabelString ? (
    <Text textStyle="label" color="text.subtle" py="1px">
      {label}
    </Text>
  ) : (
    label
  );

  return (
    <Stack direction="column" spacing="0" w="auto">
      <>{Label}</>
      <Heading as="h4" variant="h4">
        {value}
      </Heading>
    </Stack>
  );
};
